import { createNullableProvideInject } from '@collector/shared-ui'

import { EventStatusAcronymConfig } from '../configuration'

export const [provideEventStatusAcronymConfig, injectEventStatusAcronymConfig] =
  createNullableProvideInject<EventStatusAcronymConfig>(
    'eventStatusAcronymConfig',
  )
